import { render, staticRenderFns } from "./CurrencyRete.vue?vue&type=template&id=18f8f898"
import script from "./CurrencyRete.vue?vue&type=script&lang=js"
export * from "./CurrencyRete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports